module.exports = __webpack_public_path__ + "static/media/BMOGreyLogo.93c64790.png";